/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetVersionInfoDto
 */
export interface GetVersionInfoDto {
    /**
     * 
     * @type {string}
     * @memberof GetVersionInfoDto
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof GetVersionInfoDto
     */
    buildTime: string;
    /**
     * 
     * @type {string}
     * @memberof GetVersionInfoDto
     */
    commit: string;
}

export function GetVersionInfoDtoFromJSON(json: any): GetVersionInfoDto {
    return GetVersionInfoDtoFromJSONTyped(json, false);
}

export function GetVersionInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetVersionInfoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'buildTime': json['buildTime'],
        'commit': json['commit'],
    };
}

export function GetVersionInfoDtoToJSON(value?: GetVersionInfoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'buildTime': value.buildTime,
        'commit': value.commit,
    };
}


